var Materials = (function(){

    function Materials(){
        THREE.Object3D.call(this);

        var geometry = new THREE.SphereGeometry(50, 28, 15);

        var matBasic = new THREE.MeshBasicMaterial({color: 0x3facc8, transparent: true});
        var matLambert = new THREE.MeshLambertMaterial({color: 0x3facc8, transparent: true});
        var matPhong = new THREE.MeshPhongMaterial({color: 0x3facc8, shininess: 50, transparent: true});
        var matShader = new THREE.ShaderMaterial({
            fragmentShader: ShaderMaterialShader.fragmentShader, 
            vertexShader: ShaderMaterialShader.vertexShader, 
            uniforms: ShaderMaterialShader.uniforms, 
            transparent: true
        });

        this.balls = [];
        
        this.balls.push(new THREE.Mesh(geometry, matBasic));
        this.balls.push(new THREE.Mesh(geometry, matShader));
        this.balls.push(new THREE.Mesh(geometry, matLambert));
        this.balls.push(new THREE.Mesh(geometry, matPhong));
        
        this.balls[0].position.x -= 175;
        this.balls[1].position.x -= 175;

        this.balls[2].position.x += 75;
        this.balls[3].position.x += 75;

        this.balls[0].position.y += 55;
        this.balls[2].position.y += 55;
        this.balls[1].position.y -= 55;
        this.balls[3].position.y -= 55;

        this.add(this.balls[0]);
        this.add(this.balls[1]);
        this.add(this.balls[2]);
        this.add(this.balls[3]);

        this.tl = new TimelineMax();
        this.tl.fromTo(this.balls[0].material, 1, {opacity: 0}, {opacity: 1}, 0);
        this.tl.fromTo(this.balls[0].position, 1, {x: -375}, {x: -175, ease: Expo.easeOut}, 0);
        this.tl.fromTo(this.balls[1].material.uniforms.opacity, 1, {value: 0}, {value: 1}, 0.1);
        this.tl.fromTo(this.balls[1].position, 1, {x: -375}, {x: -175, ease: Expo.easeOut}, 0.1);
        this.tl.fromTo(this.balls[2].material, 1, {opacity: 0}, {opacity: 1}, 0.2);
        this.tl.fromTo(this.balls[2].position, 1, {x: 275}, {x: 75, ease: Expo.easeOut}, 0.2);
        this.tl.fromTo(this.balls[3].material, 1, {opacity: 0}, {opacity: 1}, 0.3);
        this.tl.fromTo(this.balls[3].position, 1, {x: 275}, {x: 75, ease: Expo.easeOut}, 0.3);
    }

    Materials.prototype = new THREE.Object3D;
    Materials.prototype.constructor = Materials;

    Materials.prototype.update = function() {
        this.balls[1].rotation.x += 0.01;
        this.balls[1].rotation.y += 0.01;
    };

    return Materials;
})();